import { NgxUploaderModule } from '@angular-ex/uploader';
import { TransactionListService } from './shared/services/transaction-list.service';
import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { TransactionShellComponent } from './transaction-shell/transaction-shell.component';
import { TransactionLookupResolveService } from './shared/services/transaction-lookup-resolve.service';
import { SharedModule } from '../../shared/shared.module';
import { TransactionsRoutingModule } from './transactions-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';
import { TransactionEditComponent } from './transaction-edit/transaction-edit.component';
import { OrderConfirmationDialogComponent } from './order-confirmation-dialog/order-confirmation-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    TransactionsRoutingModule,
    SharedModule,
    NgxUploaderModule,
    CheckboxModule,
    ListboxModule,
    NgbModule,
  ],
  providers: [TransactionListService, TransactionLookupResolveService],
  declarations: [
    TransactionListComponent,
    TransactionShellComponent,
    TransactionEditComponent,
    OrderConfirmationDialogComponent,
  ],
})
export class TransactionsModule {}
